import { mapCollection } from '../../utils/collection.utils';
import { ReadMode } from '../read-mode';

export class ReadModeBuilder {
  static fromJson(json) {
    return (json)
      ? new ReadMode(
        json.name,
        json.code,
      )
      : null;
  }

  static fromList(list) {
    return mapCollection(ReadModeBuilder.fromJson, list);
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/read-mode.builder.ts